// extracted by mini-css-extract-plugin
export default {"root":"_2OckJ","spotifyFrame":"_35x2H","rootInEditor":"xMWHl","rootInViewer":"_1IGlY"};